import { useAuctionAuctionFinish } from './events/auction/useAuctionAuctionFinish'
import { useAuctionAuctionPause } from './events/auction/useAuctionAuctionPause'
import { useAuctionAuctionPublish } from './events/auction/useAuctionAuctionPublish'
import { useAuctionAuctionResume } from './events/auction/useAuctionAuctionResume'
import { useAuctionAuctionWithdraw } from './events/auction/useAuctionAuctionWithdraw'

export const AUCTION_SOCKET_CALLBACK = 'auction-update'

export function useAuctionSocket() {
  const { auctionPause } = useAuctionAuctionPause()
  const { auctionResume } = useAuctionAuctionResume()
  const { auctionWithdraw } = useAuctionAuctionWithdraw()
  const { auctionPublish } = useAuctionAuctionPublish()
  const { auctionFinish } = useAuctionAuctionFinish()

  const init = () => {
    auctionPause()
    auctionResume()
    auctionWithdraw()
    auctionPublish()
    auctionFinish()
  }

  return { init }
}
